import { formatDateForLoyalty } from "../../../common/releaseDateBanner/formatDateForLoyalty";

export default function getMembersDayTranslations(
  getTranslation,
  endDate,
  isMembersDay,
) {
  const copyKey = isMembersDay
    ? "members_day_live_landing_page_hero_sub_copy"
    : "members_day_plan_your_buy_pdp_notification";

  const dateKey = isMembersDay
    ? "members_day_plan_your_buy_prices_start_date_subtitle"
    : "members_day_start_date_subtitle";

  return {
    priceBanner: getTranslation("members_day_live_taping_title"),
    copy: getTranslation(copyKey),
    dateSubtitle: getTranslation(dateKey, {
      endDate: formatDateForLoyalty(endDate),
    }),
    buttonText: getTranslation("download_the_app_cta_title"),
  };
}
